// The Drop & Go screens - the ones a maid walks through beside the customer:
// the basket list, the booking form, the summary, payment, history and the
// receipt, plus the older staff service screens still routed under
// /drop-and-go/service.
//
// Merged into the app dictionary in utils/i18n.js, same as locales/maid.js.
// The receipt's own slogan line is left in Thai on purpose - it is the shop's
// wording, not an instruction to translate.

const dropgoTranslations = {
  th: {
    // Shell
    "dg.refresh": "รีเฟรช",
    "dg.load_error": "เกิดข้อผิดพลาดในการโหลดข้อมูล กรุณาลองใหม่อีกครั้ง",
    "dg.load_error_short": "เกิดข้อผิดพลาดในการโหลดข้อมูล",
    "dg.loading": "กำลังโหลดข้อมูล...",
    "dg.loading_short": "กำลังโหลด...",
    "dg.loading_image": "กำลังโหลดรูปภาพ…",
    "dg.no_active": "ไม่มีรายการกำลังดำเนินการ",
    "dg.add_basket": "เพิ่มตะกร้า",
    "dg.review": "รีวิว",
    "dg.branch_missing": "ไม่พบข้อมูลสาขา กรุณาเข้าสู่ระบบใหม่",
    "dg.update_failed": "ไม่สามารถอัพเดทสถานะได้ กรุณาลองใหม่อีกครั้ง",
    "dg.cannot_process": "ไม่สามารถทำรายการได้ กรุณาลองใหม่อีกครั้ง",
    "dg.incomplete_data": "ข้อมูลไม่ครบถ้วน",
    "dg.cannot_start_machine": "ไม่สามารถเริ่มเครื่องได้",
    "dg.contact_maid": "โปรดติดต่อแม่บ้าน เพื่อใช้บริการ",
    "dg.scan_qr": "สแกน QR Code บนหน้าเครื่อง",
    "dg.scan_qr_hint": "ที่ท่านต้องใช้งาน",
    "dg.use_service": "ใช้บริการ",
    "dg.wallet_short": "จำนวนเงิน ในกระเป๋าเงิน ของคุณ ไม่เพียงพอ",
    "dg.wallet_topup_hint": "เพื่อทำรายการให้สำเร็จกรุณาเติมเงินในกระเป๋าเงินของคุณ",
    "dg.top_up_now": "เติมเงินตอนนี้",
    "dg.wallet_paid": "ชำระเงินผ่านกระเป๋าเงินสำเร็จ",

    // Figures on a card
    "dg.customer": "ลูกค้า",
    "dg.phone": "เบอร์โทร",
    "dg.queue": "ลำดับคิว",
    "dg.queue_short": "คิว",
    "dg.queue_label": "หมายเลขคิว",
    "dg.basket_queue": "คิวตะกร้า",
    "dg.basket_queue_laundry": "คิวตะกร้าผ้า",
    "dg.pickup_queue": "คิวรับผ้า",
    "dg.credit_total": "จำนวนที่มี",
    "dg.credit_used": "ใช้ไป",
    "dg.credit_left": "คงเหลือ",
    "dg.machine": "เครื่อง",
    "dg.branch": "สาขา",
    "dg.branch_code": "รหัสสาขา {code}",
    "dg.receipt_number": "เลขที่ใบเสร็จ",
    "dg.updated_at": "อัพเดทล่าสุด",
    "dg.hour": "น.",
    "dg.km": "กม.",
    "dg.cctv": "กล้องวงจรปิด",
    "dg.parking": "ที่จอดรถ",
    "dg.washer_count": "เครื่องซัก {count}",
    "dg.dryer_count": "เครื่องอบ {count}",
    "dg.total_extra": "รวมราคา +{count}",
    "dg.cancelled": "ยกเลิกแล้ว",

    // Stages
    "dg.stage.drop": "DROP ผ้า",
    "dg.stage.wash": "ซัก",
    "dg.stage.dry": "อบ",
    "dg.stage.finish": "เสร็จสิ้น",
    "dg.stage.receive": "รับผ้า",
    "dg.stage.deliver": "ส่งผ้า",

    // Services and money
    "dg.services": "การใช้บริการ",
    "dg.discounts": "ส่วนลด",
    "dg.payment": "ชำระเงิน",
    "dg.price": "ราคา",
    "dg.total_all": "รวมทั้งหมด",
    "dg.amount_to_pay": "จำนวนเงินที่ต้องชำระ",
    "dg.wash_size": "ซัก {size}",
    "dg.dry_size": "อบ {size}",
    "dg.washer_size": "เครื่องซัก {size}",
    "dg.dryer_size": "เครื่องอบ {size}",
    "dg.detergent_count": "น้ำยาซักผ้า {count}",
    "dg.softener_count": "น้ำยาปรับผ้านุ่ม {count}",
    "dg.detergent_packs": "น้ำยาซักผ้า {count} ซอง",
    "dg.softener_packs": "น้ำยาปรับผ้านุ่ม {count} ซอง",
    "dg.detergent_short": "น้ำยาซัก",
    "dg.softener_short": "น้ำยาปรับ",
    "dg.extra_dry": "เพิ่มเวลาอบ {minutes} นาที",
    "dg.extra_dry_label": "เพิ่มเวลาอบ",
    "dg.wash_colon": "ซักผ้า :",
    "dg.dry_colon": "อบผ้า :",
    "dg.detergent_colon": "น้ำยา :",
    "dg.extra_time_colon": "เพิ่มเวลา :",
    "dg.none": "ไม่มี",
    "dg.service_fee": "ค่าบริการ Drop&Go",
    "dg.deposit_fee": "ค่าบริการรับฝากผ้า",
    "dg.service_discount": "ส่วนลดค่าบริการ",
    "dg.service_fee_discount": "ส่วนลดค่าบริการ Drop&Go",
    "dg.status_discount": "ส่วนลดสถานะ: {level}",
    "dg.status_discount_gold": "ส่วนลดสถานะ Gold",
    "dg.member_discount": "ส่วนลดสถานะสมาชิก",
    "dg.accumulated_discount": "ส่วนลดแบบสะสม",
    "dg.point_discount": "ส่วนลดแต้ม",
    "dg.points_discount": "ส่วนลดคะแนนสะสม",
    "dg.coupon_discount": "ส่วนลดคูปอง",
    "dg.redeem_points": "แลกคะแนนและสะสมเพื่อรับส่วนลด",
    "dg.use_points": "ใช้แต้มเพื่อรับส่วนลดค่าบริการ",
    "dg.confirm_payment": "ยืนยันการชำระเงิน",
    "dg.confirm_your_payment": "ยืนยันการชำระเงินของคุณ",

    // Temperatures
    "dg.temp.high": "สูง",
    "dg.temp.medium": "ปานกลาง",
    "dg.temp.low": "ต่ำ",
    "dg.temp.no_heat": "ไม่มีความร้อน",
    "dg.temp.high_full": "อุณหภูมิสูง",
    "dg.temp.medium_full": "อุณหภูมิปานกลาง",
    "dg.temp.low_full": "อุณหภูมิต่ำ",

    // Member block on the receipt
    "dg.member": "สมาชิก",
    "dg.member_status": "สถานะ",
    "dg.points": "คะแนนสะสม",
    "dg.points_earned": "ได้รับคะแนน",
    "dg.points_used": "ใช้คะแนน",
    "dg.points_left": "คงเหลือ",
    "dg.print_receipt": "พิมพ์ใบเสร็จ",
    "dg.thanks": "ขอบคุณที่ใช้บริการ",
    "dg.view_status": "ดูสถานะ",

    // Photos
    "dg.proof": "หลักฐาน",
    "dg.proof_numbered": "หลักฐาน {index}",
    "dg.image_failed": "โหลดรูปไม่สำเร็จ",
    "dg.no_image": "ไม่มีรูป",
    "dg.upload_done_photo": "อัปโหลดรูปภาพ ที่เสร็จสิ้นแล้ว",
    "dg.note": "*หมายเหตุ",

    // History
    "dg.history_title": "ประวัติการใช้ DROP & GO",
    "dg.no_history": "ไม่มีประวัติการใช้งาน",
    "dg.no_history_dropgo": "ไม่มีประวัติการใช้งาน Drop&Go",
    "dg.status.pending": "รอดำเนินการ",
    "dg.status.preparing": "กำลังเตรียม",
    "dg.status.in_progress": "กำลังดำเนินการ",
    "dg.status.completed": "เสร็จสิ้น",
    "dg.status.waiting_pickup": "รอรับผ้า",
    "dg.status.done": "สำเร็จ",
    "dg.status.cancelled": "ยกเลิก",

    // Staff service screens
    "dg.tab.new_basket": "ตะกร้าใหม่",
    "dg.tab.preparing": "กำลังเตรียม",
    "dg.tab.working": "กำลังทำงาน",
    "dg.tab.completed": "เสร็จสิ้น",
    "dg.tab.receive": "รับผ้า",
    "dg.backup": "สำรอง",
    "dg.positive_integer": "ต้องเป็นจำนวนเต็มบวก",
    "dg.waiting_maid_line1": "รอการยืนยัน",
    "dg.waiting_maid_line2": "จากแม่บ้าน",

    // Terms of service shown before booking
    "dg.tos.title": "เงื่อนไขการใช้บริการ",
    "dg.tos.process_heading": "การดำเนินการ",
    "dg.tos.process_body":
      "พนักงานจะดำเนินการซักและอบผ้าตามโปรแกรมมาตรฐาน ของทางร้านเท่านั้น",
    "dg.tos.liability_heading": "การจำกัดความรับผิดชอบ",
    "dg.tos.liability_body":
      "ทางร้านของสงวนสิทธิ์ ไม่รับผิดชอบต่อความเสียหายที่อาจเกิดขึ้นกับเนื้อผ้าในทุกกรณี เช่น:",
    "dg.tos.liability_shrink": "การหดตัว หรือการเสียรูปทรงของเนื้อผ้า",
    "dg.tos.liability_colour": "ปัญหาทางเคมี เช่น สีตก หรือสีซีดจาง",
    "dg.tos.liability_pocket":
      "ความเสียหายที่เกิดจากสิ่งของตกค้างในกระเป๋าผ้า (เช่น ปากกา, ไฟแช็ก, เหรียญ)",
    "dg.confirmed_line1": "ยืนยัน รับตระกร้า",
    "dg.confirmed_line2": "จากแม่บ้าน",
    "dg.cancelling": "กำลังยกเลิก...",
    "dg.cancel_too_late": "ไม่สามารถยกเลิกได้ แม่บ้านยืนยันการรับผ้าแล้ว",
    "dg.cancel_failed": "เกิดข้อผิดพลาดในการยกเลิก กรุณาลองใหม่อีกครั้ง",
    "dg.tos.care_body":
      "ข้อควรระวัง: รบกวนลูกค้ากรุณาตรวจสอบความเหมาะสมของเนื้อผ้า (Care Label) และตรวจเช็คสิ่งของในกระเป๋าให้เรียบร้อยก่อนส่งมอบให้พนักงานทุกครั้ง ขอขอบพระคุณลูกค้าทุกท่านที่ไว้วางใจใช้บริการ LAUNDRY STATION ครับ/ค่ะ",
    "dg.tos.accept": "ยอมรับ",
  },

  en: {
    "dg.refresh": "Refresh",
    "dg.load_error": "Could not load the data, please try again",
    "dg.load_error_short": "Could not load the data",
    "dg.loading": "Loading...",
    "dg.loading_short": "Loading...",
    "dg.loading_image": "Loading the photo…",
    "dg.no_active": "Nothing in progress",
    "dg.add_basket": "Add a basket",
    "dg.review": "Review",
    "dg.branch_missing": "Branch not found, please sign in again",
    "dg.update_failed": "Could not update the status, please try again",
    "dg.cannot_process": "Could not complete this, please try again",
    "dg.incomplete_data": "Some details are missing",
    "dg.cannot_start_machine": "Could not start the machine",
    "dg.contact_maid": "Please speak to the staff to use this service",
    "dg.scan_qr": "Scan the QR code on the machine",
    "dg.scan_qr_hint": "you want to use",
    "dg.use_service": "Use the service",
    "dg.wallet_short": "Your wallet balance is not enough",
    "dg.wallet_topup_hint": "Top up your wallet to complete this",
    "dg.top_up_now": "Top up now",
    "dg.wallet_paid": "Paid from the wallet",

    "dg.customer": "Customer",
    "dg.phone": "Phone",
    "dg.queue": "Queue no.",
    "dg.queue_short": "Queue",
    "dg.queue_label": "Queue number",
    "dg.basket_queue": "Basket no.",
    "dg.basket_queue_laundry": "Laundry basket no.",
    "dg.pickup_queue": "Pickup no.",
    "dg.credit_total": "Credit",
    "dg.credit_used": "Used",
    "dg.credit_left": "Remaining",
    "dg.machine": "Machine",
    "dg.branch": "Branch",
    "dg.branch_code": "Branch code {code}",
    "dg.receipt_number": "Receipt number",
    "dg.updated_at": "Last updated",
    "dg.hour": "",
    "dg.km": "km",
    "dg.cctv": "CCTV",
    "dg.parking": "Parking",
    "dg.washer_count": "{count} washers",
    "dg.dryer_count": "{count} dryers",
    "dg.total_extra": "Total +{count}",
    "dg.cancelled": "Cancelled",

    "dg.stage.drop": "DROP",
    "dg.stage.wash": "Wash",
    "dg.stage.dry": "Dry",
    "dg.stage.finish": "Done",
    "dg.stage.receive": "Collect",
    "dg.stage.deliver": "Hand over",

    "dg.services": "Services used",
    "dg.discounts": "Discounts",
    "dg.payment": "Amount paid",
    "dg.price": "Price",
    "dg.total_all": "Total",
    "dg.amount_to_pay": "Amount to pay",
    "dg.wash_size": "Wash {size}",
    "dg.dry_size": "Dry {size}",
    "dg.washer_size": "Washer {size}",
    "dg.dryer_size": "Dryer {size}",
    "dg.detergent_count": "Detergent {count}",
    "dg.softener_count": "Softener {count}",
    "dg.detergent_packs": "Detergent {count} packs",
    "dg.softener_packs": "Softener {count} packs",
    "dg.detergent_short": "Detergent",
    "dg.softener_short": "Softener",
    "dg.extra_dry": "Extra drying {minutes} min",
    "dg.extra_dry_label": "Extra drying",
    "dg.wash_colon": "Wash:",
    "dg.dry_colon": "Dry:",
    "dg.detergent_colon": "Detergent:",
    "dg.extra_time_colon": "Extra time:",
    "dg.none": "None",
    "dg.service_fee": "Drop&Go service fee",
    "dg.deposit_fee": "Laundry drop-off fee",
    "dg.service_discount": "Service discount",
    "dg.service_fee_discount": "Drop&Go service discount",
    "dg.status_discount": "Status discount: {level}",
    "dg.status_discount_gold": "Gold status discount",
    "dg.member_discount": "Membership discount",
    "dg.accumulated_discount": "Loyalty discount",
    "dg.point_discount": "Points discount",
    "dg.points_discount": "Points discount",
    "dg.coupon_discount": "Coupon discount",
    "dg.redeem_points": "Redeem points for a discount",
    "dg.use_points": "Use points for a service discount",
    "dg.confirm_payment": "Confirm payment",
    "dg.confirm_your_payment": "Confirm your payment",

    "dg.temp.high": "High",
    "dg.temp.medium": "Medium",
    "dg.temp.low": "Low",
    "dg.temp.no_heat": "No heat",
    "dg.temp.high_full": "High heat",
    "dg.temp.medium_full": "Medium heat",
    "dg.temp.low_full": "Low heat",

    "dg.member": "Member",
    "dg.member_status": "Status",
    "dg.points": "Points",
    "dg.points_earned": "Points earned",
    "dg.points_used": "Points used",
    "dg.points_left": "Remaining",
    "dg.print_receipt": "Print receipt",
    "dg.thanks": "Thank you for your visit",
    "dg.view_status": "View status",

    "dg.proof": "Proof",
    "dg.proof_numbered": "Proof {index}",
    "dg.image_failed": "Could not load the photo",
    "dg.no_image": "No photo",
    "dg.upload_done_photo": "Upload the finished-laundry photo",
    "dg.note": "*Note",

    "dg.history_title": "DROP & GO history",
    "dg.no_history": "No history yet",
    "dg.no_history_dropgo": "No Drop&Go history yet",
    "dg.status.pending": "Waiting",
    "dg.status.preparing": "Preparing",
    "dg.status.in_progress": "In progress",
    "dg.status.completed": "Done",
    "dg.status.waiting_pickup": "Waiting for collection",
    "dg.status.done": "Completed",
    "dg.status.cancelled": "Cancelled",

    "dg.tab.new_basket": "New basket",
    "dg.tab.preparing": "Preparing",
    "dg.tab.working": "Working",
    "dg.tab.completed": "Done",
    "dg.tab.receive": "Collect",
    "dg.backup": "Backup",
    "dg.positive_integer": "Must be a positive whole number",
    "dg.waiting_maid_line1": "Waiting for the staff",
    "dg.waiting_maid_line2": "to confirm",

    "dg.tos.title": "Terms of service",
    "dg.tos.process_heading": "How the work is done",
    "dg.tos.process_body":
      "Staff wash and dry the laundry on the shop's standard programmes only",
    "dg.tos.liability_heading": "Limits of liability",
    "dg.tos.liability_body":
      "The shop does not accept liability for damage to fabric in any case, such as:",
    "dg.tos.liability_shrink": "Shrinkage or loss of shape",
    "dg.tos.liability_colour": "Chemical effects such as colour running or fading",
    "dg.tos.liability_pocket":
      "Damage caused by items left in pockets (pens, lighters, coins)",
    "dg.confirmed_line1": "The staff has taken",
    "dg.confirmed_line2": "your basket",
    "dg.cancelling": "Cancelling...",
    "dg.cancel_too_late":
      "Too late to cancel - the staff has already taken the laundry",
    "dg.cancel_failed": "Could not cancel, please try again",
    "dg.tos.care_body":
      "Please check that the fabric is suitable (care label) and that pockets are empty before handing the laundry to our staff. Thank you for trusting LAUNDRY STATION.",
    "dg.tos.accept": "Accept",
  },

  my: {
    "dg.refresh": "ပြန်လည်စတင်",
    "dg.load_error": "အချက်အလက်ဖတ်၍မရပါ၊ ထပ်မံကြိုးစားပါ",
    "dg.load_error_short": "အချက်အလက်ဖတ်၍မရပါ",
    "dg.loading": "အချက်အလက်ဖွင့်နေသည်...",
    "dg.loading_short": "ဖွင့်နေသည်...",
    "dg.loading_image": "ဓာတ်ပုံဖွင့်နေသည်…",
    "dg.no_active": "ဆောင်ရွက်ဆဲစာရင်းမရှိပါ",
    "dg.add_basket": "တောင်းထည့်ရန်",
    "dg.review": "သုံးသပ်ချက်",
    "dg.branch_missing": "ဆိုင်ခွဲအချက်အလက်မတွေ့ပါ၊ ပြန်လည်ဝင်ရောက်ပါ",
    "dg.update_failed": "အခြေအနေမပြင်နိုင်ပါ၊ ထပ်မံကြိုးစားပါ",
    "dg.cannot_process": "ဆောင်ရွက်၍မရပါ၊ ထပ်မံကြိုးစားပါ",
    "dg.incomplete_data": "အချက်အလက်မပြည့်စုံပါ",
    "dg.cannot_start_machine": "စက်ကိုစတင်၍မရပါ",
    "dg.contact_maid": "ဝန်ဆောင်မှုရယူရန် ဝန်ထမ်းကိုဆက်သွယ်ပါ",
    "dg.scan_qr": "စက်ပေါ်ရှိ QR ကုဒ်ကိုဖတ်ပါ",
    "dg.scan_qr_hint": "အသုံးပြုလိုသော",
    "dg.use_service": "ဝန်ဆောင်မှုအသုံးပြုရန်",
    "dg.wallet_short": "သင့်ပိုက်ဆံအိတ်တွင် ငွေမလုံလောက်ပါ",
    "dg.wallet_topup_hint": "ဆက်လက်ဆောင်ရွက်ရန် ပိုက်ဆံအိတ်တွင် ငွေဖြည့်ပါ",
    "dg.top_up_now": "ယခုငွေဖြည့်ရန်",
    "dg.wallet_paid": "ပိုက်ဆံအိတ်မှ ပေးချေပြီးပါပြီ",

    "dg.customer": "ဖောက်သည်",
    "dg.phone": "ဖုန်းနံပါတ်",
    "dg.queue": "တန်းစီနံပါတ်",
    "dg.queue_short": "တန်းစီ",
    "dg.queue_label": "တန်းစီနံပါတ်",
    "dg.basket_queue": "တောင်းနံပါတ်",
    "dg.basket_queue_laundry": "အဝတ်တောင်းနံပါတ်",
    "dg.pickup_queue": "အဝတ်ယူနံပါတ်",
    "dg.credit_total": "စုစုပေါင်းငွေ",
    "dg.credit_used": "သုံးပြီး",
    "dg.credit_left": "ကျန်ငွေ",
    "dg.machine": "စက်",
    "dg.branch": "ဆိုင်ခွဲ",
    "dg.branch_code": "ဆိုင်ခွဲကုဒ် {code}",
    "dg.receipt_number": "ငွေလက်ခံဖြတ်ပိုင်းနံပါတ်",
    "dg.updated_at": "နောက်ဆုံးပြင်ဆင်ချိန်",
    "dg.hour": "နာရီ",
    "dg.km": "ကီလိုမီတာ",
    "dg.cctv": "CCTV ကင်မရာ",
    "dg.parking": "ကားရပ်နားရန်",
    "dg.washer_count": "အဝတ်လျှော်စက် {count}",
    "dg.dryer_count": "အခြောက်ခံစက် {count}",
    "dg.total_extra": "စုစုပေါင်းဈေး +{count}",
    "dg.cancelled": "ပယ်ဖျက်ပြီး",

    "dg.stage.drop": "အဝတ်ချ",
    "dg.stage.wash": "လျှော်",
    "dg.stage.dry": "အခြောက်ခံ",
    "dg.stage.finish": "ပြီးဆုံး",
    "dg.stage.receive": "အဝတ်ယူ",
    "dg.stage.deliver": "အဝတ်ပေးအပ်",

    "dg.services": "အသုံးပြုသောဝန်ဆောင်မှု",
    "dg.discounts": "လျှော့ဈေး",
    "dg.payment": "ပေးချေငွေ",
    "dg.price": "ဈေးနှုန်း",
    "dg.total_all": "စုစုပေါင်းအားလုံး",
    "dg.amount_to_pay": "ပေးချေရမည့်ငွေပမာဏ",
    "dg.wash_size": "လျှော် {size}",
    "dg.dry_size": "အခြောက်ခံ {size}",
    "dg.washer_size": "အဝတ်လျှော်စက် {size}",
    "dg.dryer_size": "အခြောက်ခံစက် {size}",
    "dg.detergent_count": "ဆပ်ပြာရည် {count}",
    "dg.softener_count": "အဝတ်ပျော့ဆေး {count}",
    "dg.detergent_packs": "ဆပ်ပြာရည် {count} ထုပ်",
    "dg.softener_packs": "အဝတ်ပျော့ဆေး {count} ထုပ်",
    "dg.detergent_short": "ဆပ်ပြာရည်",
    "dg.softener_short": "အဝတ်ပျော့ဆေး",
    "dg.extra_dry": "အခြောက်ခံအချိန်ထပ်ထည့် {minutes} မိနစ်",
    "dg.extra_dry_label": "အခြောက်ခံအချိန်ထပ်ထည့်",
    "dg.wash_colon": "အဝတ်လျှော် -",
    "dg.dry_colon": "အခြောက်ခံ -",
    "dg.detergent_colon": "ဆပ်ပြာရည် -",
    "dg.extra_time_colon": "အချိန်ထပ်ထည့် -",
    "dg.none": "မရှိပါ",
    "dg.service_fee": "Drop&Go ဝန်ဆောင်ခ",
    "dg.deposit_fee": "အဝတ်အပ်နှံခ",
    "dg.service_discount": "ဝန်ဆောင်ခလျှော့ဈေး",
    "dg.service_fee_discount": "Drop&Go ဝန်ဆောင်ခလျှော့ဈေး",
    "dg.status_discount": "အဆင့်လျှော့ဈေး - {level}",
    "dg.status_discount_gold": "Gold အဆင့်လျှော့ဈေး",
    "dg.member_discount": "အသင်းဝင်အဆင့်လျှော့ဈေး",
    "dg.accumulated_discount": "စုဆောင်းလျှော့ဈေး",
    "dg.point_discount": "အမှတ်လျှော့ဈေး",
    "dg.points_discount": "စုဆောင်းအမှတ်လျှော့ဈေး",
    "dg.coupon_discount": "ကူပွန်လျှော့ဈေး",
    "dg.redeem_points": "အမှတ်လဲပြီး လျှော့ဈေးရယူပါ",
    "dg.use_points": "အမှတ်သုံးပြီး ဝန်ဆောင်ခလျှော့ဈေးရယူပါ",
    "dg.confirm_payment": "ငွေပေးချေမှုအတည်ပြုရန်",
    "dg.confirm_your_payment": "သင့်ငွေပေးချေမှုကို အတည်ပြုပါ",

    "dg.temp.high": "မြင့်",
    "dg.temp.medium": "အလယ်အလတ်",
    "dg.temp.low": "နိမ့်",
    "dg.temp.no_heat": "အပူမပါ",
    "dg.temp.high_full": "အပူချိန်မြင့်",
    "dg.temp.medium_full": "အပူချိန်အလယ်အလတ်",
    "dg.temp.low_full": "အပူချိန်နိမ့်",

    "dg.member": "အသင်းဝင်",
    "dg.member_status": "အဆင့်",
    "dg.points": "စုဆောင်းအမှတ်",
    "dg.points_earned": "ရရှိသောအမှတ်",
    "dg.points_used": "သုံးပြီးအမှတ်",
    "dg.points_left": "ကျန်ရှိအမှတ်",
    "dg.print_receipt": "ငွေလက်ခံဖြတ်ပိုင်းပရင့်ထုတ်",
    "dg.thanks": "ဝန်ဆောင်မှုအသုံးပြုသည့်အတွက် ကျေးဇူးတင်ပါသည်",
    "dg.view_status": "အခြေအနေကြည့်ရန်",

    "dg.proof": "အထောက်အထား",
    "dg.proof_numbered": "အထောက်အထား {index}",
    "dg.image_failed": "ဓာတ်ပုံဖွင့်၍မရပါ",
    "dg.no_image": "ဓာတ်ပုံမရှိပါ",
    "dg.upload_done_photo": "ပြီးဆုံးသောအဝတ်ဓာတ်ပုံတင်ရန်",
    "dg.note": "*မှတ်ချက်",

    "dg.history_title": "DROP & GO မှတ်တမ်း",
    "dg.no_history": "မှတ်တမ်းမရှိသေးပါ",
    "dg.no_history_dropgo": "Drop&Go မှတ်တမ်းမရှိသေးပါ",
    "dg.status.pending": "စောင့်ဆိုင်းဆဲ",
    "dg.status.preparing": "ပြင်ဆင်နေ",
    "dg.status.in_progress": "ဆောင်ရွက်နေ",
    "dg.status.completed": "ပြီးဆုံး",
    "dg.status.waiting_pickup": "အဝတ်ယူရန်စောင့်ဆိုင်း",
    "dg.status.done": "အောင်မြင်ပြီး",
    "dg.status.cancelled": "ပယ်ဖျက်ပြီး",

    "dg.tab.new_basket": "တောင်းအသစ်",
    "dg.tab.preparing": "ပြင်ဆင်နေ",
    "dg.tab.working": "ဆောင်ရွက်နေ",
    "dg.tab.completed": "ပြီးဆုံး",
    "dg.tab.receive": "အဝတ်ယူ",
    "dg.backup": "အရန်စက်",
    "dg.positive_integer": "အပြုသဘောကိန်းပြည့်ဖြစ်ရမည်",
    "dg.waiting_maid_line1": "ဝန်ထမ်း၏အတည်ပြုချက်ကို",
    "dg.waiting_maid_line2": "စောင့်ဆိုင်းနေသည်",

    "dg.tos.title": "ဝန်ဆောင်မှုစည်းကမ်းချက်",
    "dg.tos.process_heading": "ဆောင်ရွက်ပုံ",
    "dg.tos.process_body":
      "ဝန်ထမ်းများသည် ဆိုင်၏စံပရိုဂရမ်ဖြင့်သာ လျှော်ဖွပ်အခြောက်ခံပေးပါသည်",
    "dg.tos.liability_heading": "တာဝန်ကန့်သတ်ချက်",
    "dg.tos.liability_body":
      "အထည်အလိပ်ပျက်စီးမှုအတွက် ဆိုင်မှတာဝန်မယူပါ၊ ဥပမာ -",
    "dg.tos.liability_shrink": "အထည်ကျုံ့ခြင်း သို့မဟုတ် ပုံပျက်ခြင်း",
    "dg.tos.liability_colour": "အရောင်ထွက်ခြင်း သို့မဟုတ် အရောင်မှိန်ခြင်း",
    "dg.tos.liability_pocket":
      "အိတ်ကပ်ထဲကျန်ရစ်သောပစ္စည်းများ (ဘောပင်၊ မီးခြစ်၊ အကြွေစေ့) ကြောင့်ဖြစ်သောပျက်စီးမှု",
    "dg.confirmed_line1": "ဝန်ထမ်းက သင့်တောင်းကို",
    "dg.confirmed_line2": "လက်ခံပြီးပါပြီ",
    "dg.cancelling": "ပယ်ဖျက်နေသည်...",
    "dg.cancel_too_late":
      "ပယ်ဖျက်၍မရတော့ပါ - ဝန်ထမ်းက အဝတ်ကိုလက်ခံပြီးဖြစ်သည်",
    "dg.cancel_failed": "ပယ်ဖျက်၍မရပါ၊ ထပ်မံကြိုးစားပါ",
    "dg.tos.care_body":
      "သတိပြုရန် - အဝတ်အထည်၏ ထိန်းသိမ်းမှုအညွှန်း (care label) ကိုစစ်ဆေးပြီး အိတ်ကပ်များတွင် ပစ္စည်းမကျန်စေရန် စစ်ဆေးပြီးမှ ဝန်ထမ်းထံအပ်ပါ။ LAUNDRY STATION ကို ယုံကြည်အားထားသည့်အတွက် ကျေးဇူးတင်ပါသည်။",
    "dg.tos.accept": "လက်ခံသည်",
  },
};

export default dropgoTranslations;
